export default __webpack_public_path__ + "static/media/imageLogo2.7b03e7a9.png";